export const REQUEST_STARTED = 'REQUEST_STARTED' as const;
export const REQUEST_FULFILLED = 'REQUEST_FULFILLED' as const;
export const REQUEST_FAILED = 'REQUEST_FAILED' as const;
export const RESET_DELETION_STATUS = 'RESET_DELETION_STATUS' as const;
export const SET_ERROR = 'SET_ERROR' as const;
export const RESET_ERROR = 'RESET_ERROR' as const;

export const requestStarted = () => ({ type: REQUEST_STARTED });

export const requestFulfilled = () => ({ type: REQUEST_FULFILLED });

export const requestFailed = () => ({ type: REQUEST_FAILED });

export const resetDeletionStatus = () => ({ type: RESET_DELETION_STATUS });

export const setError = (message: string) => ({
  type: SET_ERROR,
  payload: message,
});

export const resetError = () => ({ type: RESET_ERROR });
